(() => {
  const slugify = (value) => value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  const initializeArticle = (article) => {
    const content = article.querySelector('[data-mk-editorial-content]');
    const toc = article.querySelector('[data-mk-table-of-contents]');
    const progress = article.querySelector('[data-mk-reading-progress]');
    if (!content) return;

    // Legacy article HTML contains Bloggle controls and external assets. Remove only
    // the duplicated navigation and sell-first sliders; retain prose, images, the
    // Klaviyo form, and plain editorial product links.
    content.querySelectorAll('#bloggy--article script, #bloggy--article link, #bloggy--article style').forEach((node) => node.remove());
    content.querySelectorAll('.bggle_table-of-content').forEach((node) => node.remove());
    content.querySelectorAll('.bggle_product-slider').forEach((slider) => {
      const precedingHeading = slider.previousElementSibling;
      if (precedingHeading && precedingHeading.matches('h2, h3, h4')) precedingHeading.remove();
      slider.remove();
    });
    content.querySelectorAll('img[data-src]').forEach((image) => {
      if (!image.getAttribute('src') && image.dataset.src) image.setAttribute('src', image.dataset.src);
      if (!image.getAttribute('srcset') && image.dataset.srcset) image.setAttribute('srcset', image.dataset.srcset);
      image.setAttribute('loading', 'lazy');
    });

    const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => {
      const text = heading.textContent.trim().toLowerCase();
      if (text === 'table of contents') {
        heading.remove();
        return false;
      }
      return text.length > 0;
    });

    if (toc && headings.length) {
      const list = document.createElement('ul');
      const ids = new Set();
      headings.forEach((heading, index) => {
        let id = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
        const original = id;
        let duplicate = 2;
        while (ids.has(id) || document.querySelectorAll(`#${CSS.escape(id)}`).length > 1) {
          id = `${original}-${duplicate++}`;
        }
        ids.add(id);
        heading.id = id;

        const item = document.createElement('li');
        if (heading.tagName.toLowerCase() === 'h3') item.className = 'is-subheading';
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });
      toc.appendChild(list);
    } else if (toc) {
      const details = toc.closest('details');
      if (details) details.hidden = true;
    }

    content.querySelectorAll('h2, h3').forEach((heading) => {
      if (heading.textContent.trim().toLowerCase() === 'shop related products') {
        heading.classList.add('mk-editorial-inline-shop-heading');
        const next = heading.nextElementSibling;
        if (next && next.tagName.toLowerCase() === 'ul') next.classList.add('mk-editorial-inline-shop-list');
      }
    });

    const updateProgress = () => {
      if (!progress) return;
      const start = article.getBoundingClientRect().top + window.scrollY;
      const end = start + article.offsetHeight - window.innerHeight;
      const current = window.scrollY;
      const percent = end > start ? Math.max(0, Math.min(100, ((current - start) / (end - start)) * 100)) : 0;
      article.style.setProperty('--mk-reading-progress', `${percent}%`);
    };
    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);

    const copy = article.querySelector('[data-mk-copy-link]');
    if (copy) {
      copy.addEventListener('click', async () => {
        const label = copy.querySelector('[data-mk-copy-label]');
        try {
          await navigator.clipboard.writeText(window.location.href);
          if (label) {
            const original = label.textContent;
            label.textContent = 'Link copied';
            window.setTimeout(() => { label.textContent = original; }, 1800);
          }
        } catch (error) {
          window.prompt('Copy this link:', window.location.href);
        }
      });
    }
  };

  const initialize = () => document.querySelectorAll('[data-mk-editorial-article]').forEach(initializeArticle);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
